import axios from 'axios';
axios.defaults.baseURL = 'https://healthbudddy.herokuapp.com';
export default axios;